import { makeTokenStore } from './tokenStorage';

// 「管理者編集」トークン：30分の短命セッションなので、タブを閉じたら消えるsessionStorageに保存する。
const store = makeTokenStore(sessionStorage, 'gj_kanri_edit_token');

export const saveKanriEditToken = store.save;
export const clearKanriEditToken = store.clear;
export const getStoredKanriEditToken = store.get;
